/**
 * created by xcc on 2022/5/23
 * 网站投递关系选择树组件
 */
import React, {Component} from 'react';
import {Select} from "antd";
import './websiteDeliverRelation.css';
import CmTree from "../../components/CmTree/CmTree";

const {Option} = Select;

export default class SelectTree extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    /**
     * 渲染
     */
    render() {
        return (
            <div style={{display: "flex", flexDirection: "column"}}>
                <div>
                    <Select className={"websiteSelect"}
                            placeholder={"请选择"}
                            value={this.props.selectedKey}
                            style={{width: "200px"}}
                            onChange={(selectedKey) => {
                                this.props.getScreenTreeData(selectedKey);
                            }}>
                        {this.props.treeData && this.props.treeData.length > 0 && this.props.treeData.map((item, index) => {
                            return (
                                <Option key={index} value={item.key}>{item.title}</Option>
                            )
                        })}
                    </Select>
                </div>
                <div style={{height: 360}}>
                    {
                        this.props.newTreeData.length ?
                            <CmTree
                                treeData={this.props.newTreeData}
                                onExpand={(expandedKeys) => {
                                    this.props.onExpand(expandedKeys)
                                }}
                                expandedKeys={this.props.expandedKeys}
                                showIcon={true}
                                autoExpandParent={this.props.autoExpandParent}
                                checkStrictly={true}
                                checkable={true}
                                isCheckAble={(item)=>{
                                    return !item.children.length && this.props.newTreeData[0].children.length > 0;   //子节点是否选中，只有根节点也不让选中
                                }}
                                onCheck={(checkedKeys, e) => {
                                    this.props.onCheck(checkedKeys, e)
                                }}
                                checkedKeys={this.props.checkedKeys}
                                selectable={false}
                            /> : null}
                </div>
            </div>
        )
    }
}